export default {"src":"/_next/static/media/noReduction.bf084f1b.svg","height":69,"width":70,"blurWidth":0,"blurHeight":0};